export default __webpack_public_path__ + "static/media/logo-transpac.f40e0ede.png";